var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"product-card",attrs:{"id":"product"}},[_c('p',[_c('span',[_vm._v(_vm._s(_vm.product.id)+" "+_vm._s(_vm.product.name))])])])}
var staticRenderFns = []

export { render, staticRenderFns }